<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'TakeFilter',
          name: 'take'
        },
        {
          type: 'WhereFilter',
          label: 'ID',
          attributes: 'user_id'
        },
        {
          type: 'WhereLikeFilter',
          label: 'Name',
          attributes: 'user.name'
        }
      ]"
      v-model="filter"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <v-table
      url="/api/v1/userSession"
      :filter="filter"
      :attributes="[
        {
          attribute: 'user.name',
          name: 'Name',
          sortable: false
        },
        {
          attribute: 'created_at',
          name: 'Datum',
          type: 'DateTimeCell',
          sortable: false
        },
        {
          attribute: 'ip',
          name: 'IP-Adresse'
        },
        {
          attribute: 'country_code',
          name: 'Land',
          type: 'FlagCell',
          sortable: false
        },
        {
          attribute: 'session_id',
          name: 'Session-ID'
        },
        {
          attribute: 'user_agent',
          name: 'Browser- und Gerätedaten'
        },
        {
          attribute: 'role_name',
          name: 'Rolle',
          sortable: false
        },
        {
          attribute: 'duration',
          name: 'Zeitspanne',
          sortable: false
        },
        {
          attribute: 'success',
          name: 'Erfolgreich eingeloggt',
          type: 'CheckMarkerCell'
        }
      ]"
    >
      <div slot="title">Anmeldungen</div>
    </v-table>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      filter: [
        {name: 'with', value: 'user'},
        {name: 'adminAndProfilebuilder'}
      ],
    };
  },
};
</script>
